<template>
  <div>
    <div style="margin-bottom:5px" :class="['dropdown_select_container', !isEditable ? 'view_only' : '']">
      <v-select v-if="isEditable" style="min-width:265px" id="assignedToLogistic"
        v-model="orderMetadata.logisticsUserId" @input="viewModal" :reduce="(user) => user.id" label="nameLabel"
        :options="filteredUsers" placeholder="Choose..." :disabled="$route.params.id <= 0 ||
          !(isLogistics || isFinance || isSponsor) ||
          isReadOnly ||
          isCompletedOrder || !isEditable
          ">
        <template v-slot:option="option">
          {{ option.nameLabel }}
        </template>
      </v-select>
      <p class="dropdown_text_wrap" v-else>
        <i v-if="selectedUserLabel.isLocked && !isPartnerAccount" class="tim-icons icon-lock-circle" aria-hidden="true"></i>
        {{ selectedUserLabel.label }}
      </p>
      <el-button style="margin-left:2px" size="mini" v-if="($route.params.id != 0 ||
        (isLogistics || isFinance || isSponsor) ||
        !isReadOnly ||
        !isCompletedOrder) && !isPartnerAccount
      " :class="isEditable ? 'editing' : 'btn-secondary'" v-show="!isReadOnly"
        :icon="isEditable ? 'el-icon-close' : 'el-icon-edit'" @click="toggleEdit()"
        :disabled="$route.params.id <= 0"
        ></el-button>
    </div>

    <!-- small modal -->
    <modal :showClose="false" :show.sync="modals.notice" headerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="title title-up">CHANGE LOGISTICS USER</h4>
      <hr />
      <div class="container">
        <div class="form-group">
          <base-checkbox v-model="sendAssignerCopy">Send Me a Copy</base-checkbox>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Note">
              <textarea class="form-control" placeholder="Add a brief description" rows="5" v-model="note"></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button style="margin-right: 2px"  type="danger" class="alert_footer_button btn_extra_small btn_info" @click.native="cancel">
            Close
          </base-button>
          <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="confirm">
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Modal, BaseButton, BaseCheckbox } from "@/components";
import {
  Button,
} from "element-ui";
export default {
  name: "logistics-user-select",
  // this orderIdProp is used to edit transaction in a modal method, it will be passed in from the transaction Index page
  // if we go this way. it can be removed if we don't use the modal method
  props: ["isLogisticsUser", "isReadOnly", "orderIdProp"],
  data() {
    return {
      modals: {
        notice: false,
      },
      sendAssignerCopy: false,
      note: null,
      selectedUserId: null,
      isEditable: false
    };
  },
  components: {
    Modal,
    BaseButton,
    BaseCheckbox,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      logisticsUsers: "users/logisticsUsers",
      authenticatedUserId: "authentication/authUserId",
      orderMetadata: "orderMetadata/orderMetadata",
      logisticsUserId: "orderMetadata/logisticsUserId",
      isLogistics: "authentication/isLogistics",
      isPartnerAccount: "authentication/isPartnerAccount",
      isFinance: "authentication/isFinance",
      isSponsor: "authentication/isSponsor",
      transaction: "transactions/transaction",
    }),
    isCompletedOrder() {
      return this.orderMetadata.orderStatus == "COMPLETED";
    },
    selectedUserLabel() {
      // Three-step user resolution:
      // 1) orderMetadata.logisticsUserNameLabel - authoritative source from backend (Name (email) format)
      // 2) logisticsUsers dropdown array - for locked status detection and editing
      // 3) transaction.logisticsUser object - backup for locked status
      
      let userIdToFind;
      
      if (this.selectedUserId) {
        userIdToFind = this.selectedUserId;
      } else {
        userIdToFind = this.logisticsUserId;
      }
      
      // If no user ID, return default message
      if (!userIdToFind) {
        return { label: 'No logistic user selected', isLocked: false };
      }

      // Primary: Use orderMetadata label (always available from backend)
      if (this.orderMetadata && this.orderMetadata.logisticsUserNameLabel) {
        // Check if user is locked via dropdown array or transaction
        let isLocked = false;
        const selectedUser = this.logisticsUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
        if (selectedUser) {
          isLocked = selectedUser.isDisabled || false;
        } else if (this.transaction && this.transaction.logisticsUser) {
          const logUser = this.transaction.logisticsUser;
          if ((logUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase()) {
            isLocked = logUser.isDisabled || false;
          }
        }
        return { label: this.orderMetadata.logisticsUserNameLabel, isLocked: isLocked };
      }

      // Fallback for dropdown array (when editing)
      const selectedUser = this.logisticsUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
      if (selectedUser) {
        return { label: selectedUser.nameLabel, isLocked: selectedUser.isDisabled || false };
      }

      // Fallback for transaction object
      if (this.transaction && this.transaction.logisticsUser) {
        const logUser = this.transaction.logisticsUser;
        const logUserIdMatch = (logUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase();
        if (logUserIdMatch) {
          const userName = (logUser.userName && logUser.userName.trim()) ? logUser.userName : logUser.userEmail;
          return {
            label: `${userName} (${logUser.userEmail})`,
            isLocked: logUser.isDisabled || false
          };
        }
      }

      // Should never reach here - backend always provides label
      return { label: 'No logistic user selected', isLocked: false };
    },
    filteredUsers() {
      // Base list excludes locked users
      const base = this.logisticsUsers.filter((e) => !e.isDisabled);

      // Ensure currently assigned user appears even if locked so the v-select can resolve the label
  const selectedId = this.orderMetadata && this.orderMetadata.logisticsUserId ? this.orderMetadata.logisticsUserId : this.selectedUserId;
      if (!selectedId) return base;

  const selectedInAll = this.logisticsUsers.find(u => (u.id || '').toLowerCase() === (selectedId || '').toLowerCase());
  const alreadyInBase = base.find(u => (u.id || '').toLowerCase() === (selectedId || '').toLowerCase());
      if (selectedInAll && !alreadyInBase) {
        return [selectedInAll, ...base];
      }

      return base;
    }
  },
  async mounted() {
    let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
    await this.getOrderMetadata(id);
    await this.getTransaction(id);


    if (this.$route.params.id == 0 && this.isLogistics) {
      this.clearAuthenticatedUser()
      await this.getUserByEmail()
      this.orderMetadata.logisticsUserId = this.authenticatedUserId
    } else {
      this.selectedUserId = this.orderMetadata.logisticsUserId
    }
  },
  methods: {
    ...mapActions({
      onLogisticsChange: "orderMetadata/onLogisticsChange",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      getUserByEmail: "authentication/getUserByEmail",
      clearAuthenticatedUser: "authentication/clearAuthenticatedUser",
      getTransaction: "transactions/getTransaction",


    }),
    viewModal(e) {
      if (e) {
        this.selectedUserId = e;
        this.modals.notice = true;
      }
    },
    async toggleEdit() {
      if (this.isEditable) {
        await this.cancel();
        this.orderMetadata.logisticsUserId = this.selectedUserId
        this.isEditable = false
      } else {
        this.isEditable = true
      }
    },
    async cancel(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;

      await this.getOrderMetadata(id);
      this.modals.notice = false;
      this.selectedUserId = this.orderMetadata.logisticsUserId
    },
    async confirm(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? ctx.$route.params.id : this.orderIdProp;
      try {
        this.$loaderApp.addRequest();

        if (this.selectedUserId == null) {
          ctx.$toast.error("Please select a user");
          ctx.modals.notice = false;
          this.$loaderApp.completeRequest();
          this.isEditable = false
          return;
        }
        const response = await ctx.onLogisticsChange({
          orderId: id,
          sendAssignerCopy: ctx.sendAssignerCopy,
          note: ctx.note,
          selectedUserId: ctx.selectedUserId,
        });
        await ctx.getOrderMetadata(id);
        if (response && response.data) {
             ctx.$toast.success(response.data);
         }
        this.isEditable = false
        this.$loaderApp.completeRequest();
        ctx.modals.notice = false;
      } catch (error) {
        ctx.$toast.error("Error Occurred! Please try again later.");
        this.isEditable = false
        this.$loaderApp.completeRequest();
      }
    },
  },
};
</script>
<style>
.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}
</style>
